// Flash applied to whatever a validation issue points at.
export const HIGHLIGHT_CLASSES = "bg-amber-50 ring-2 ring-inset ring-amber-400";
